import styles from "../../styles/components/mypage/homeMarketMobile.module.css";
import { useRouter } from "next/router";

export default function HomeMarketMobile({
  marketRows, // 부모가 계산해서 보낸 마켓 줄 데이터 [ [6개], [6개] ]
  hotdealRows, // 부모가 계산해서 보낸 핫딜 줄 데이터
  marketPage, // 현재 마켓 페이지 번호
  setMarketPage, // 마켓 페이지 변경 함수
  totalMarketPages, // 마켓 총 페이지 수
  hotDealPage, // 현재 핫딜 페이지 번호
  setHotDealPage, // 핫딜 페이지 변경 함수
  totalHotDealPages, // 핫딜 총 페이지 수
  activeTabChild,
  setActiveTabChild,
}) {
  const router = useRouter();

  // 현재 활성화된 탭에 따른 변수들 (화살표 로직용)
  const isMarket = activeTabChild === "market";
  const currentPage = isMarket ? marketPage : hotDealPage;
  const totalPages = isMarket ? totalMarketPages : totalHotDealPages;
  const setCurrentPage = isMarket ? setMarketPage : setHotDealPage;
  return (
    <>
      <div className={styles.homeMarket}>
        <div className={styles.homeMarketTitle}>
          <div className={styles.homeMarketTitle_Contents}>
            {/* 왼쪽 탭 영역 */}
            <div className={styles.homeMarketTitleLe_Tab}>
              {/* 첫 번째 탭: 마켓플레이스 */}
              <div
                className={styles.menuTabOption}
                onClick={() => setActiveTabChild("market")} // 클릭 시 상태를 "market"으로 변경
                style={{ cursor: "pointer" }} // 마우스 포인터 모양 변경
              >
                <div className={styles.menuTabOption_Contents}>
                  <div
                    className={`${
                      activeTabChild === "market"
                        ? styles.menuTabOption_Text
                        : styles.menuTabOption_Basic
                    } body2`}
                  >
                    마켓플레이스
                  </div>
                </div>
                <div className={styles.menuTabOption_Line}></div>
              </div>

              {/* 두 번째 탭: 핫딜 */}
              <div
                className={styles.menuTabOption}
                onClick={() => setActiveTabChild("hotdeal")} // 클릭 시 상태를 "hotdeal"으로 변경
                style={{ cursor: "pointer" }} // 마우스 포인터 모양 변경
              >
                <div className={styles.menuTabOption_Contents}>
                  <div
                    className={`${
                      activeTabChild === "hotdeal"
                        ? styles.menuTabOption_Text
                        : styles.menuTabOption_Basic
                    } body2`}
                  >
                    핫딜
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.homeMarketSe_Group}>
          {/* --- 섹션 1: 마켓플레이스 전용 반복문 --- */}
          {activeTabChild === "market" &&
            marketRows.map((group, gIdx) => (
              <div
                key={`market-row-${gIdx}`}
                className={styles.homeMarketSeRe_Repeat}
              >
                {group.map((item, iIdx) => (
                  <div
                    key={item.id || iIdx}
                    className={styles.homeCard}
                    onClick={() =>
                      router.push(`/parts/inventory/${item.it_id}`)
                    }
                    style={{ cursor: "pointer" }} // 마우스 포인터 모양 변경
                  >
                    {/* 이미지 영역 */}
                    <div
                      className={
                        item?.it_img1?.trim() &&
                        item?.it_img1.startsWith("https")
                          ? styles.homeCardFi_image
                          : styles.homeCardFi_Noimage
                      }
                    >
                      {item?.it_img1?.trim() &&
                      item?.it_img1.startsWith("https") ? (
                        <img
                          src={item.it_img1}
                          className={styles.image}
                          alt="상품"
                          onError={(e) => {
                            e.target.src = "/images/noimageKO.jpg";
                          }}
                        />
                      ) : (
                        <img
                          src="/images/noimageKO.jpg"
                          className={styles.image}
                          alt="상품"
                        />
                      )}
                      <div className={styles.labelHomeBlack}>
                        {/* SVG 생략 (기존 것 유지) */}
                        <div
                          className={`${styles.labelHome_Text_White} label2`}
                        >
                          견적요청
                        </div>
                      </div>
                    </div>
                    {/* 정보 영역 */}
                    <div className={styles.homeCardSe_Info}>
                      <div className={styles.homeCardSeFi_ItemInfo}>
                        <div
                          className={`${styles.homeCardSeFiFi_Name} body3`}
                        >
                          {item.it_name}
                        </div>
                        <div
                          className={`${styles.homeCardSeFiSe_Maker} caption2`}
                        >
                          {item.it_brand}
                        </div>
                        <div className={styles.homeCardSeFiTh_tag}>
                          <div className={styles.labelHome}>
                            <div
                              className={`${styles.labelHome_Text} label2`}
                            >
                              특가제공
                            </div>
                          </div>
                          <div className={styles.labelHomeGray}>
                            <div
                              className={`${styles.labelHome_Text_Gray} label2`}
                            >
                              바로출고
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={styles.homeCardSeSe_Inventory}>
                        {/* 재고 아이콘 SVG 생략 */}
                        <div className={styles.homeCardSeSeRi_TextGroup}>
                          <div
                            className={`${styles.homeCardSeSeRiLe_Num} body3`}
                          >
                            {Number(item.it_stock_qty).toLocaleString()}
                          </div>
                          <div
                            className={`${styles.homeCardSeSeRiRi_Unit} caption2`}
                          >
                            개
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {/* 빈 공간 채우기 */}
                {group.length < 2 &&
                  Array.from({ length: 2 - group.length }).map((_, index) => (
                    <div
                      className={styles.homeCard}
                      style={{ visibility: "hidden" }}
                    >
                      <div className={styles.homeCardFi_image}>
                        <img
                          src={"/images/noimageKO.jpg"}
                          className={styles.image}
                          alt="핫딜"
                        />
                        <div className={styles.labelHomeRed}>
                          <div
                            className={`${styles.labelHome_Text_White} label2`}
                          ></div>
                        </div>
                      </div>
                      <div className={styles.homeCardSe_Info}>
                        <div className={styles.homeCardSeFi_ItemInfo}>
                          <div
                            className={`${styles.homeCardSeFiFi_Name} body3`}
                          ></div>
                          <div
                            className={`${styles.homeCardSeFiSe_Maker} caption2`}
                          ></div>
                          <div
                            className={`${styles.homeCardSeFiTh_Price} caption2`}
                          ></div>
                        </div>
                        <div className={styles.homeCardSeSe_Inventory}>
                          {/* 핫딜용 재고/단가 SVG 생략 */}
                          <div className={styles.homeCardSeSeRi_TextGroup}>
                            <div
                              className={`${styles.homeCardSeSeRiLe_Num} body3`}
                            ></div>
                            <div
                              className={`${styles.homeCardSeSeRiRi_Unit} caption2`}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            ))}

          {/* --- 섹션 2: 핫딜 전용 반복문 --- */}
          {activeTabChild === "hotdeal" &&
            hotdealRows.map((group, gIdx) => (
              <div
                key={`hotdeal-row-${gIdx}`}
                className={styles.homeMarketSeRe_Repeat}
              >
                {group.map((item, iIdx) => (
                  <div
                    key={item.id || iIdx}
                    className={styles.homeCard}
                    onClick={() =>
                      router.push(`/parts/mallview/${item.it_id}`)
                    }
                  >
                  <div                         className={
                        item?.it_img1?.trim() &&
                        item?.it_img1.startsWith("https")
                          ? styles.homeCardFi_image
                          : styles.homeCardFi_Noimage
                      }>
                                              {item?.it_img1?.trim() &&
                      item?.it_img1.startsWith("https") ? (
                        <img
                          src={item.it_img1}
                          className={styles.image}
                          alt="핫딜"
                          onError={(e) => {
                            e.target.src = "/images/noimageKO.jpg";
                          }}
                        />
                      ) : (
                        <img
                          src="/images/noimageKO.jpg"
                          className={styles.image}
                          alt="핫딜"
                        />
                      )}
                      <div className={styles.labelHomeRed}>
                        <div
                          className={`${styles.labelHome_Text_White} label2`}
                        >
                          구매하기
                        </div>
                      </div>
                    </div>
                    <div className={styles.homeCardSe_Info}>
                      <div className={styles.homeCardSeFi_ItemInfo}>
                        <div
                          className={`${styles.homeCardSeFiFi_Name} body3`}
                        >
                          {item.it_name}
                        </div>
                        <div
                          className={`${styles.homeCardSeFiSe_Maker} caption2`}
                        >
                          {item.it_brand}
                        </div>
                        <div
                          className={`${styles.homeCardSeFiTh_Price} caption2`}
                        >
                          {Number(item.it_price_before).toLocaleString()}원
                        </div>
                      </div>
                      <div className={styles.homeCardSeSe_Inventory}>
                        {/* 핫딜용 재고/단가 SVG 생략 */}
                        <div className={styles.homeCardSeSeRi_TextGroup}>
                          <div
                            className={`${styles.homeCardSeSeRiLe_Num} body3`}
                          >
                            {Number(item.it_price).toLocaleString()}
                          </div>
                          <div
                            className={`${styles.homeCardSeSeRiRi_Unit} caption2`}
                          >
                            원
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {/* 빈 공간 채우기 */}
                {group.length < 2 &&
                  Array.from({ length: 2 - group.length }).map((_, index) => (
                    <div
                      className={styles.homeCard}
                      style={{ visibility: "hidden" }}
                    >
                      <div className={styles.homeCardFi_image}>
                        <img
                          src={"/images/noimageKO.jpg"}
                          className={styles.image}
                          alt="핫딜"
                        />
                        <div className={styles.labelHomeRed}>
                          <div
                            className={`${styles.labelHome_Text_White} label2`}
                          ></div>
                        </div>
                      </div>
                      <div className={styles.homeCardSe_Info}>
                        <div className={styles.homeCardSeFi_ItemInfo}>
                          <div
                            className={`${styles.homeCardSeFiFi_Name} body3`}
                          ></div>
                          <div
                            className={`${styles.homeCardSeFiSe_Maker} caption2`}
                          ></div>
                          <div
                            className={`${styles.homeCardSeFiTh_Price} caption2`}
                          ></div>
                        </div>
                        <div className={styles.homeCardSeSe_Inventory}>
                          {/* 핫딜용 재고/단가 SVG 생략 */}
                          <div className={styles.homeCardSeSeRi_TextGroup}>
                            <div
                              className={`${styles.homeCardSeSeRiLe_Num} body3`}
                            ></div>
                            <div
                              className={`${styles.homeCardSeSeRiRi_Unit} caption2`}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            ))}
          {/* --- 더보기 버튼 영역 --- */}
          {/* 1. 현재 페이지가 전체 페이지보다 작을 때만 버튼을 노출합니다. */}
          {currentPage < totalPages && (
            <div
              className={styles.buttonSeeMore}
              /* 2. 클릭 시 현재 페이지 번호를 1 증가시킵니다. */
              onClick={() => setCurrentPage(currentPage + 1)}
              style={{ cursor: "pointer" }}
            >
              <div className={`${styles.buttonSeeMore_Text} body4`}>
                주문내역 더보기
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
              >
                <path
                  d="M10.3245 4.30048C10.6418 4.61778 10.6418 5.1321 10.3245 5.4494L7.07452 8.6994C6.92215 8.85178 6.71555 8.93744 6.50006 8.93744C6.28457 8.93744 6.07797 8.85177 5.9256 8.6994L2.6756 5.4494C2.3583 5.1321 2.3583 4.61778 2.6756 4.30048C2.9929 3.98317 3.50722 3.98317 3.82452 4.30048L6.50006 6.97601L9.1756 4.30048C9.4929 3.98317 10.0072 3.98317 10.3245 4.30048Z"
                  fill="#2F2F2F"
                />
              </svg>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
